import _ from 'underscore';
import { MATCH_TYPE_IDS } from '@bingads-webui-campaign/recommendation-core';

export function InlineEditableSave({
  key,
  view,
  updated,
  editorView,
}) {
  const recommendation = view.grid.gridView.itemWithKey(key);
  if (!_.isNull(recommendation)) {
    _.first(recommendation.Opportunities).NewMatchType = MATCH_TYPE_IDS[updated.MatchType.toUpperCase()]; // eslint-disable-line

    // Append the current selected one into existing selected ones.
    const selectedKeys = view.grid.gridView.selectedKeys();
    if (!_.contains(selectedKeys, key)) {
      selectedKeys.push(key);
    }
    view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });
  }
  editorView.trigger('cancel');
}
